import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { GET_VIEWUSERLIST } from '../../actions';
import { mediaUrl} from'../Config/Config';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import moment from 'moment';
class ViewEHR extends Component {

  constructor(props)
  {
    super(props); 
    const userid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

    this.state = {      
      userid: userid,
      userlistview:'',
      familtlistview:'',
      pastappointment:'',
      ongoingappts:'',
      futureappts:'',
      activetab: 'userdetail',  
      ShowFamilyDocuments:false,
      FamilyDocuments:'',
      medicalHistorylist:'',
      medicalCondition:'',
      ShowPrescriptionlist:'',
      Prescriptionlist:'',
      RaiseDisputelist:'',
      isActive:true,
    };

    var qs = require('qs');
    var postObject = {             
    id   :userid
    };
    this.props.getViewUserList(qs.stringify(postObject));  
  }

   
   componentDidMount() {
     document.title = PageTitle('User View');
     if ($('.sidebar-menu').hasClass('menu-close')) {
          $('.sidebar-menu').removeClass('menu-close');
          $('.logo-box').removeClass('active');	
            $('.header-cnt-left').removeClass('toggle-open');
      }else{
          $('.sidebar-menu').addClass('menu-close');
          $('.logo-box').addClass('active');
            $('.header-cnt-left').addClass('toggle-open');
    }
   }

   componentDidUpdate(prevProps,prevState){

   }
   componentWillReceiveProps(Props){
      if(Props.userlistview!==this.state.userlistview){
        if(Props.userlistview[0].status == "success"){
          this.setState({userlistview: Props.userlistview[0].userlistview[0]}) 
          this.setState({familtlistview: Props.userlistview[0].familylist},function(){
            this.familylist();
          }) 
         
          this.setState({pastappointment: Props.userlistview[0].pastappointment},function(){
            this.pastappointment();
          }) 
          this.setState({ongoingappts: Props.userlistview[0].ongoingappts},function(){
            this.ongoingappts();
          }) 
          this.setState({futureappts: Props.userlistview[0].futureappts},function(){
            this.futureappts();
          }) 
          // this.setState({medicalHistorylist:Props.userlistview[0].usermedicalfiles},function(){
          //   this.medicalHistory();
          // }) 
          // this.setState({RaiseDisputelist:Props.userlistview[0].raise_dispute},function(){
          //   this.RaiseDisputelist();
          // }) 
          this.setState({medicalCondition:Props.userlistview[0].medicalcondition},function(){
            this.medicalCondition();
          })
        }
      }
   }
   familylist() {
    var familtlist = this.state.familtlistview;
    if (familtlist != "undefined" && familtlist != null) {
      // if ( == "success"){
        if (Object.keys(familtlist).length > 0) {
          const familylistDetails = familtlist.map(
            (familtlist, Index) => {
              if(familtlist.petgender == 'Male'){
                var gen = 'M';
              }else{
                var gen = 'F';
              }
              let sno = Index+1;
              return (
                <tr key={familtlist.id}>
				         <td>{sno}</td>
                 <td>
                  {familtlist.pet_name} 
                  </td>
                
                   <td>
                  {familtlist.pettype}
                  </td>
                    
                  <td>
                  {familtlist.petcolor}
                  </td> 

                    
                  <td>
                  {familtlist.petgender}
                  </td> 

                  <td>
                  {familtlist.petage}
                  </td>
                  <td>
                  {familtlist.petweight}
                  </td>

                   <td>
                  {familtlist.allergies}
                  </td>
                  <td>
                  {familtlist.vaccination}
                  </td>

                  <td>
                  {familtlist.surgery_done}
                  </td>





                 {/*<td>
                  {familtlist.contact_no!== null?familtlist.contact_no:'-'}
                  </td> */}
                  {/* <td>
                  <a class="" title="View" href="#" onClick={this.ShowFamilyDocuments.bind(this,familtlist.family_member_documents)}>  <i class="ft-eye" aria-hidden="true"></i></a>
                  </td> */}
                 
                 
                </tr>
              );
            }
          );
          return familylistDetails;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }

  pastappointment() {
    var appointments = this.state.pastappointment;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>
                  {appts.name}
                  </td>
                  <td>
                  {appts.petname}
                  </td>
                   <td>
                  {appts.petvisit}
                  </td>
                 
                  <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                
                
                  {/* <td>
                  {appts.gender}
                  </td>
                 
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}
                  <td>
                    {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:''}

                    
                  </td>
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }

  ongoingappts() {
    var appointments = this.state.ongoingappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>
                  {appts.name}
                  </td>

                  <td>
                  {appts.petname}
                  </td>
                 <td>
                  {appts.petvisit}
                  </td>
                 
                  <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                  {/* <td>
                  {appts.gender}
                  </td>
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}
                  <td>
                    {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:''}

                    
                  </td>
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  apptPrescriptionShow = (preslist)=>{
    this.setState({ShowPrescriptionlist:true,Prescriptionlist:preslist});
  }
  apptPrescriptionlist = (preslist)=>{
 
    var preslist = this.state.Prescriptionlist;
    if (preslist != "undefined" && preslist != null) {
      // if ( == "success"){
        if (Object.keys(preslist).length > 0) {
          const apptDlist = preslist.map(
            (data, Index) => {
              let sno = Index+1;
            
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{data.prescription_name}</td>
                 <td>{data.quantity}</td>
                 <td>{data.price}</td>
                 {/* <td>{data.created_on}</td> */}
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
    
  }
  futureappts() {
    var appointments = this.state.futureappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>
                  {appts.name}
                  </td>
                  <td>
                  {appts.petname}
                  </td>
                  <td>
                  {appts.petvisit}
                  </td>

                 <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
              
                 
                
                  {/* <td>
                  {appts.gender}
                  </td>
                 
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}
                
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  medicalCondition = ()=>{
    var medicalCondition = this.state.medicalCondition;
    if (medicalCondition != "undefined" && medicalCondition != null) {
      // if ( == "success"){
        if (Object.keys(medicalCondition).length > 0) {
          const medlist = medicalCondition.map(
            (data, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.petvisit} </p></td>
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  medicalHistory = ()=>{

    var medicalHistorylist = this.state.medicalHistorylist;
    if (medicalHistorylist != "undefined" && medicalHistorylist != null) {
      // if ( == "success"){
        if (Object.keys(medicalHistorylist).length > 0) {
          const medlist = medicalHistorylist.map(
            (medicalfile, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p> <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="10.79 5 78.42 90" onClick={() => this.downloadImage(mediaUrl+"familymedical/"+medicalfile.image,medicalfile.image)} style={{width: '30px',height: '30px'}}
 > <g data-name="pdf"><path d="M87,25.34,70.92,7.75A8.46,8.46,0,0,0,64.69,5H19.23a8.45,8.45,0,0,0-8.44,8.44V86.56A8.45,8.45,0,0,0,19.23,95H80.77a8.45,8.45,0,0,0,8.44-8.44V31A8.4,8.4,0,0,0,87,25.34Zm-5.33,2.51H71.31A2.82,2.82,0,0,1,68.5,25V13.44Zm-.9,61.53H19.23a2.82,2.82,0,0,1-2.82-2.82V13.44a2.82,2.82,0,0,1,2.82-2.82H62.87V25a8.45,8.45,0,0,0,8.44,8.44H83.59V86.56A2.82,2.82,0,0,1,80.77,89.38Z"/><path d="M67.22,28.89,66.5,9H14.67V91.33H85.5V29.12ZM40.4,53.48a6.21,6.21,0,0,1-1.79,2.22A7.6,7.6,0,0,1,36,57a11.54,11.54,0,0,1-3.16.42H31.17a1,1,0,0,0-.94.94v5.24a.94.94,0,0,1-.94.94H26.44a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h6.27a14.69,14.69,0,0,1,3.26.34A7.33,7.33,0,0,1,38.61,45a5.54,5.54,0,0,1,1.79,2.09,7.06,7.06,0,0,1,.66,3.21A7.24,7.24,0,0,1,40.4,53.48Zm18.73,5.15A8.69,8.69,0,0,1,57,61.93a8.58,8.58,0,0,1-3.24,2,12.9,12.9,0,0,1-4.2.65H44.35a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h5a14.65,14.65,0,0,1,4.35.61A8.78,8.78,0,0,1,57,46a8.28,8.28,0,0,1,2.12,3.24,13.07,13.07,0,0,1,.75,4.67A13.36,13.36,0,0,1,59.13,58.63ZM75.82,46.58a.94.94,0,0,1-.94.94H68.26a.94.94,0,0,0-.94.94v3a.94.94,0,0,0,.94.94h5.4a.94.94,0,0,1,.94.94v2.12a.94.94,0,0,1-.94.94h-5.4a.94.94,0,0,0-.94.94v6.27a.94.94,0,0,1-.94.94H63.52a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94H74.88a.94.94,0,0,1,.94.94Z"/><path d="M53.37,48.76a4.33,4.33,0,0,0-1.87-1.08,8.5,8.5,0,0,0-2.45-.32h-.9V60.69h.9a7.84,7.84,0,0,0,2.45-.35,4.65,4.65,0,0,0,1.87-1.14,5.6,5.6,0,0,0,1.21-2.08A10.08,10.08,0,0,0,55,53.93a9.8,9.8,0,0,0-.43-3.14A5.23,5.23,0,0,0,53.37,48.76Z"/><path d="M35.39,48a5.42,5.42,0,0,0-3-.68H31.17a1,1,0,0,0-.94.94V52.7a1,1,0,0,0,.94.94h1.38q3.87,0,3.87-3.35A2.55,2.55,0,0,0,35.39,48Z"/></g></svg>  {medicalfile.image} </p></td>
                 <td>{moment(medicalfile.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }

  }

  RaiseDisputelist = ()=>{
    
    var RaiseDisputelist = this.state.RaiseDisputelist;
    if (RaiseDisputelist != "undefined" && RaiseDisputelist != null) {
      // if ( == "success"){
        if (Object.keys(RaiseDisputelist).length > 0) {
          const medlist = RaiseDisputelist.map(
            (data, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.dispute} </p></td>
                 <td> <p>  {data.appointment_id} </p></td>
                 <td> <p>  {data.doctor_name} ({data.graduation}) </p></td>
                 <td> <p>  {data.dispute_message} </p></td>
                 <td> <p>  {data.dispute_status=='A'?'Active':'Inactive'}</p></td>
                 
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                                  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }
  handleGoBack = () => {
    if(this.state.ShowPrescriptionlist){
      this.setState({ShowPrescriptionlist:false});
    }else{
      this.props.history.goBack();
    }
    
  }
  handleClick = (index) => {
    this.setState({ activetab: index,ShowPrescriptionlist:false });
  };
  expandClick = () => {
    this.setState({ isActive: !this.state.isActive });
  };
  Capitalize(str){
    if (!str || typeof str !== "string") return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
    ShowFamilyDocuments=(documents)=>{
      this.setState({ShowFamilyDocuments:true,FamilyDocuments:documents});
    }
    downloadImage(url, name) {
			fetch(url)
			.then(resp => resp.blob())
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = name;
				document.body.appendChild(link);
				link.click();
				window.URL.revokeObjectURL(url);
			})
			.catch(() => alert('An error sorry'));
		}
  render() {
    const { activetab } = this.state;
     if((this.state.userlistview.membership_name!='')&&(this.state.userlistview.membership_name!=null)){
        if(this.state.userlistview.membership_name == "Free"){
         var plan_paid_amount = "$"+0;
        }else{
           var plan_paid_amount = "$"+this.state.userlistview.amount;
        }
    }else{
     var plan_paid_amount = "N/A";
    }
    if((this.state.userlistview.membership_name!='')&&(this.state.userlistview.membership_name!=null)){
        var subscribed_plan_name = this.state.userlistview.membership_name;
    }else{
     var subscribed_plan_name = "N/A";
    }
    if((this.state.userlistview.transactionId!='')&&(this.state.userlistview.transactionId!=null)){
        var transactionId = this.state.userlistview.transactionId;
    }else{
     var transactionId = "N/A";
    }

    var mobileno = ((this.state.userlistview.mobileno === null)||((this.state.userlistview.mobileno === ''))) ?  this.state.userlistview.mobileno = 'N/A' : this.state.userlistview.mobileno;

    var lastname = ((this.state.userlistview.lastname === null)||(this.state.userlistview.lastname === "")) ?  this.state.userlistview.lastname = 'N/A' : this.state.userlistview.lastname;


    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="user" />  
      
      <div className="content"> 
        <div className="content-wrapper">
         <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card">
                 <div>
                  <span className='cursor-pointer btn-arrow end' onClick={this.handleGoBack}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg></span>
               </div>
               <div className={`${this.state.isActive ? "vertical-menu-bar active" : "vertical-menu-bar"}`} onClick={this.expandClick}>
               {/* <svg version="1.1" x="0px" y="0px" viewBox="8 18 84 64" onClick={this.expandClick}><g transform="translate(0,-952.36218)"><path d="m 13,970.36219 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.76149 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.23851 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z m 0,26.99998 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5.00003 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.76153 -2.2386,-5.00003 -5,-5.00003 z m 0,27.00003 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z" fill="#000000" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg> */}
               <div>
               <h4>Pet Parent</h4>
               <div>
               <span className="icon_menu1"></span>
                    <span className="icon_menu2"></span>
                    <span className="icon_menu3"></span>
                    </div>
                    </div>
               </div> 
               <div className='title text-start mt-20px pb-0'>
               <h3>{this.Capitalize(this.state.userlistview.firstname)}'s Profile</h3>
                </div> 
               <div className='d-flex w-100 gap-4 vertical-menu-content-wrapper mt-4 min-vh-100'>
               <ul  className={`${this.state.isActive ? "vertical-menu-list active" : "vertical-menu-list"}`}>
                  <li onClick={() => this.handleClick('userdetail')} className={activetab === 'userdetail' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="5 3 22 26"><path d="M11,29H21a6,6,0,0,0,0-12H11a6,6,0,0,0,0,12Z"/><circle cx="16" cy="9" r="6"/></svg>
                    <span>User Demographics</span><span className='tooltip'>User Info</span></li>

                  <li onClick={() => this.handleClick('familylist')} className={activetab === 'familylist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="5 3 22 26"><path d="M11,29H21a6,6,0,0,0,0-12H11a6,6,0,0,0,0,12Z"/><circle cx="16" cy="9" r="6"/></svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" enable-background="new 0 0 100 100" viewBox="4.56 13.69 93.38 77.88"><path fill-rule="evenodd" clip-rule="evenodd" d="M95.934,26.48l-3.713,8.296c-1.01,1.928-2.794,3.025-5.35,3.293h-1.395  c-1.708-0.105-3.567-0.14-5.577-0.105c-2.429,0.395-4.59,0.912-6.483,1.551c-1.511,0.5-3.027,0.576-4.55,0.227  c-0.615-0.174-1.487-0.512-2.614-1.011c-0.418-0.209-1.487-0.931-3.207-2.162c-1.789-1.29-3.485-2.329-5.089-3.119  c-1.405-0.768-4.101-2.046-8.087-3.835c-2.277-1.104-3.753-2.097-4.426-2.979c-0.663-0.895-0.75-1.976-0.262-3.242  c0.267-0.72,0.808-1.255,1.621-1.604c1.138-0.581,2.498-0.535,4.079,0.14c1.904,0.86,3.224,1.453,3.956,1.778  c1.29,0.581,3.317,1.325,6.082,2.23c0.942,0.291,1.883,0.489,2.823,0.593h1.203l-1.08-0.488c-6.356-2.916-10.533-4.799-12.531-5.647  c-1.952-0.813-3.643-0.941-5.072-0.382c-1.383,0.581-2.335,1.417-2.858,2.509c-0.279,0.616-0.471,1.447-0.575,2.492  c-0.744-0.046-2.26-0.111-4.549-0.192c-4.799,2.313-7.401,3.544-7.808,3.695c-0.941,0.314-1.906,0.488-2.893,0.523  c-1.081-0.024-1.876-0.216-2.388-0.576c-0.604-0.255-1.034-0.895-1.29-1.917c-0.175-1.047,0.737-2.179,2.736-3.399l10.596-6.867  c5.101-0.603,10.08-1.423,14.937-2.457c1.068-0.244,2.103-0.145,3.102,0.296c3.115,1.604,6.659,3.23,10.632,4.88  c1.977,0.813,3.887,1.575,5.734,2.284c3.277,1.057,6.024,1.667,8.244,1.83h0.018c2.439,0.023,7.784-0.941,16.034-2.894  C98.606,19.631,98.606,21.717,95.934,26.48z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M25.73,31.831c3.405,5.019,6.298,10.091,8.68,15.215  c3.764,8.168,5.49,15.047,5.176,20.636c-0.058,0.302-0.209,0.604-0.453,0.906c-0.348,0.384-0.604,0.61-0.767,0.68  c-4.276,1.371-8.511,1.731-12.706,1.081c-6.309-1.139-11.741-4.619-16.295-10.439c0.825-7.576,2.347-13.485,4.566-17.726  l2.962-4.113C19.567,35.154,22.512,33.075,25.73,31.831z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M79.011,48.388c-0.709-0.917-1.587-1.476-2.632-1.672  c-9.572,0.235-14.992-1.101-16.261-4.009c-2.406-5.798-6.397-9.499-11.974-11.102c-5.577-1.592-11.648-0.93-18.213,1.986  c2.893,4.613,5.287,9.132,7.18,13.56c3.509,7.878,5.072,14.617,4.688,20.218c0,1.022-0.389,1.992-1.167,2.91  c-0.686,0.93-1.511,1.546-2.475,1.849c-3.01,1.01-7.129,1.301-12.357,0.871c-5.24-0.442-10.904-3.167-16.993-8.175  c-1.385,6.83-2.799,11.271-4.244,13.324c14.306,8.29,28.217,12.767,41.733,13.429c2.091-7.355,3.184-11.137,3.277-11.346  c0.523-1.36,0.837-2.133,0.941-2.318c0.244-0.406,0.546-0.784,0.906-1.133c0.789-0.778,1.69-1.243,2.702-1.395  c5.959-0.813,11.095-2.66,15.406-5.542c6.519-4.321,9.997-10.521,10.439-18.597C80.063,50.224,79.742,49.271,79.011,48.388z   M53.181,50.445c-0.686,0.674-1.51,1.01-2.475,1.01c-0.988,0-1.818-0.336-2.493-1.01c-0.685-0.674-1.028-1.505-1.028-2.492  c0-0.977,0.343-1.802,1.028-2.475c0.674-0.674,1.504-1.012,2.493-1.012c0.965,0,1.789,0.337,2.475,1.012  c0.675,0.673,1.012,1.498,1.012,2.475C54.192,48.939,53.855,49.771,53.181,50.445z"></path></svg>
                    <span>Pets</span><span className='tooltip'>Pets</span>
                    <i>{this.state.familtlistview.length}</i>
                    </li>

                  <li onClick={() => this.handleClick('pastappointment')} className={activetab === 'pastappointment' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                    <span>Past Appointments</span><span className='tooltip'>Past Appts</span><i>{this.state.pastappointment.length}</i></li>

                    <li onClick={() => this.handleClick('ongoingappts')} className={activetab === 'ongoingappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="12 12.03 76 75.97">  <path d="m85.191 68.449c-2.582 2.2148-5.6758 3.75-9 4.4609-0.011718 3.6445-0.375 7.2773-1.0898 10.852 4.3594-4.3711 7.793-9.5781 10.09-15.312zm2.7812 4v11.102h-0.003906c0.011719 1.1719-0.44531 2.3008-1.2695 3.1367s-1.9453 1.3086-3.1211 1.3125h-6.9062c4.7969-4.3438 8.6523-9.625 11.328-15.52zm-13.871-3.5391c-0.55859-0.003906-1.0898 0.21484-1.4844 0.60938-0.39453 0.39062-0.61719 0.92578-0.61719 1.4805 0 5.7305-0.46094 12.719-2.7812 17h-52.797c-1.1758 0.003906-2.3008-0.46094-3.1289-1.293-0.83203-0.82812-1.2969-1.9531-1.293-3.1289v-52.668h76v29.148c-5.3945 5.9609-10.027 8.9102-13.898 8.8516zm-44.441-56.309c-0.55859-0.55859-1.3984-0.72266-2.125-0.41406-0.72656 0.30469-1.1953 1.0234-1.1836 1.8125v4.5117c0 0.78125 0.47266 1.4883 1.1953 1.7891 0.72656 0.29688 1.5586 0.13281 2.1133-0.42188 0.37109-0.35938 0.57812-0.85156 0.57812-1.3672v-4.5117c0-0.51562-0.20703-1.0117-0.57812-1.3711zm43.422 0h-0.003906c-0.57422-0.50781-1.3906-0.64062-2.0977-0.34375-0.70703 0.29688-1.1836 0.97656-1.2188 1.7422v4.5117c0.070312 1.0195 0.92188 1.8086 1.9414 1.8086 1.0234 0 1.875-0.78906 1.9453-1.8086v-4.5117c0-0.51562-0.20313-1.0078-0.57031-1.3711zm4.7617 5.7188h5.7383-0.003906c1.1719-0.003906 2.293 0.46094 3.125 1.2852 0.82812 0.82422 1.293 1.9453 1.2969 3.1133v4h-76v-4c0.003906-2.4219 1.9648-4.3867 4.3906-4.3984h5.7383c-0.066406 1.668 0.55078 3.2969 1.707 4.5 1.1602 1.207 2.7578 1.8867 4.4297 1.8867s3.2695-0.67969 4.4258-1.8867c1.1602-1.2031 1.7773-2.832 1.707-4.5h31.172c-0.066406 1.668 0.54688 3.2969 1.707 4.5 1.1562 1.207 2.7578 1.8867 4.4258 1.8867 1.6719 0 3.2734-0.67969 4.4297-1.8867 1.1602-1.2031 1.7734-2.832 1.707-4.5zm-15.414 28.68c-3.2969-3.2969-7.7695-5.1484-12.43-5.1484-4.6641 0-9.1367 1.8516-12.434 5.1484s-5.1484 7.7656-5.1484 12.43c0 4.6641 1.8516 9.1328 5.1484 12.43s7.7695 5.1523 12.434 5.1523c4.6602 0 9.1328-1.8555 12.43-5.1523 3.293-3.2969 5.1445-7.7695 5.1445-12.43 0-4.6602-1.8516-9.1328-5.1445-12.43zm-12.43-9.3281c-5.7734 0-11.312 2.293-15.395 6.375s-6.375 9.6211-6.375 15.395c0 5.7734 2.293 11.309 6.375 15.391 4.082 4.0859 9.6211 6.3789 15.395 6.3789s11.312-2.293 15.395-6.3789c4.082-4.082 6.375-9.6172 6.375-15.391 0-5.7734-2.293-11.312-6.375-15.395s-9.6211-6.375-15.395-6.375zm4.2188 16.129-6.3008 6.7812-2.1172-2.3438c-0.34766-0.46875-0.87891-0.76953-1.4609-0.82812-0.58203-0.058594-1.1602 0.12891-1.5938 0.51953-0.4375 0.39062-0.6875 0.94141-0.69531 1.5273-0.007812 0.58594 0.23438 1.1445 0.66016 1.543l3.5508 4c0.375 0.48047 0.94531 0.76953 1.5547 0.79297 0.60938 0.027343 1.1992-0.21484 1.6133-0.66406l7.8516-8.4414v0.003906c0.38672-0.41016 0.59375-0.96094 0.57422-1.5234-0.019531-0.56641-0.26562-1.0977-0.68359-1.4766-0.40625-0.37891-0.94531-0.58203-1.5-0.55859-0.55469 0.019532-1.0781 0.25781-1.4531 0.66797z" fill-rule="evenodd"></path> </svg>
                    <span>Ongoing Appointments</span><span className='tooltip'>Ongoing Appts</span><i>{this.state.ongoingappts.length}</i></li>

                    <li onClick={() => this.handleClick('futureappts')} className={activetab === 'futureappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="6 6 88.02 88.01">  <g>   <path d="m53.68 37.879c0.03125 0.17188 0.050781 0.32812 0.050781 0.5v3.3789c10.18 1.6016 18.238 9.6719 19.852 19.852h3.3711c0.17969 0 0.35156 0.019531 0.5 0.050781-1.6406-12.352-11.441-22.141-23.781-23.789z"></path>   <path d="m80.699 19.301c1.1289 0 2.0508-0.92188 2.0508-2.0508v-9.2109c0-1.1211-0.92188-2.0391-2.0508-2.0391-1.1289 0-2.0391 0.92188-2.0391 2.0391v9.2109c0 1.1289 0.92188 2.0508 2.0391 2.0508z"></path>   <path d="m51.691 42.012v-3.6289c0-0.92969-0.73828-1.6914-1.6719-1.6914-0.92969 0-1.6992 0.75-1.6992 1.6914v3.6289c0 0.92969 0.73828 1.6992 1.6719 1.6992 0.92969 0 1.6992-0.76172 1.6992-1.6992z"></path>   <path d="m51.551 60.48v-6.9414c0-0.85156-0.69922-1.5312-1.5391-1.5312h-0.019531c-0.83984 0-1.5391 0.67969-1.5391 1.5312v6.9414c0.48828-0.14844 1-0.25 1.5508-0.25 0.55078 0 1.0586 0.10156 1.5508 0.25z"></path>   <path d="m60.238 19.301c1.1211 0 2.0391-0.92188 2.0391-2.0508l0.003906-9.2109c0-1.1211-0.92188-2.0391-2.0391-2.0391-1.1211 0-2.0508 0.92188-2.0508 2.0391v9.2109c0 1.1289 0.92188 2.0508 2.0508 2.0508z"></path>   <path d="m6 82.719c0 0.58984 0.44141 1.0586 0.98047 1.0586l19.668 0.003906c-3.5195-4.4414-5.7891-9.8789-6.3008-15.82-0.64062-0.67969-1.0508-1.5898-1.0508-2.5898s0.39844-1.9414 1.0508-2.6094c1.2617-14.352 12.711-25.809 27.059-27.059 0.67188-0.66016 1.5781-1.0586 2.5898-1.0586 1.0117 0 1.9414 0.39844 2.6016 1.0586 14.352 1.25 25.809 12.699 27.07 27.039 0.64062 0.67969 1.0508 1.5898 1.0508 2.6016s-0.39844 1.9297-1.0508 2.6016c-0.51172 5.9414-2.7812 11.398-6.3008 15.84h19.672c0.53906 0 0.98047-0.46875 0.98047-1.0586v-50.945h-88.02v50.941z"></path>   <path d="m93.02 12.129h-8.2305v3.6211c1.2617 1.1289 2.0508 2.75 2.0508 4.5586 0 3.3906-2.75 6.1406-6.1406 6.1406s-6.1289-2.75-6.1289-6.1406c0-1.8086 0.80078-3.4297 2.0391-4.5586v-3.6211h-12.281v3.6211c1.25 1.1289 2.0391 2.75 2.0391 4.5586 0 3.3906-2.75 6.1406-6.1289 6.1406-3.3789 0-6.1406-2.75-6.1406-6.1406 0-1.8086 0.80078-3.4297 2.0508-4.5586v-3.6211h-12.289v3.6211c1.2617 1.1289 2.0508 2.75 2.0508 4.5586 0 3.3906-2.75 6.1406-6.1406 6.1406s-6.1289-2.75-6.1289-6.1406c0-1.8086 0.80078-3.4297 2.0391-4.5586v-3.6211h-12.281v3.6211c1.25 1.1289 2.0391 2.75 2.0391 4.5586 0 3.3906-2.75 6.1406-6.1289 6.1406s-6.1406-2.75-6.1406-6.1406c0-1.8086 0.80078-3.4297 2.0508-4.5586v-3.6211h-8.2383c-0.53906 0-0.98047 0.46875-0.98047 1.0586v16.543h88v-16.539c0-0.58984-0.44141-1.0586-0.98047-1.0586z"></path>   <path d="m73.328 63.66c-0.92969 0-1.6914 0.75-1.6914 1.6914 0 0.94141 0.75 1.6992 1.6914 1.6992h3.6289c0.92969 0 1.6992-0.73828 1.6992-1.6719 0-0.92969-0.76172-1.7109-1.6992-1.7109h-3.6289z"></path>   <path d="m76.961 69.09h-3.3711c-1.6094 10.172-9.6719 18.238-19.852 19.84v3.3789c0 0.17969-0.019531 0.32812-0.050781 0.5 12.34-1.6406 22.141-11.441 23.781-23.781-0.16016 0.03125-0.32031 0.050781-0.5 0.050781z"></path>   <path d="m71.57 68.629c-1.1602-0.64062-1.9805-1.8516-1.9805-3.2695 0-1.4219 0.82031-2.6484 1.9805-3.2812-1.4297-9.4297-8.8711-16.871-18.289-18.301-0.64062 1.1602-1.8594 1.9688-3.2695 1.9688-1.4102 0-2.6484-0.80859-3.2891-1.9688-9.4102 1.4297-16.859 8.8711-18.289 18.301 1.1602 0.62891 1.9805 1.8516 1.9805 3.2617s-0.82031 2.6484-1.9805 3.2891c1.4297 9.4219 8.8711 16.859 18.289 18.289 0.64062-1.1719 1.8594-1.9688 3.2695-1.9688 1.4102 0 2.6484 0.80078 3.2891 1.9688 9.4102-1.4297 16.859-8.8711 18.289-18.289zm-10.32 8.4805c-0.69922 0.71094-1.6211 1.0508-2.5391 1.0508-0.92188 0-1.8398-0.33984-2.5312-1.0508l-6.5391-6.5312s-0.078125-0.10156-0.12109-0.14062c-2.6016-0.26172-4.6484-2.4297-4.6484-5.0898 0-1.4297 0.60156-2.7188 1.5391-3.6484v-8.1602c0-1.9688 1.6016-3.5781 3.5781-3.5781h0.019531c1.9805 0 3.5781 1.6094 3.5781 3.5781v8.1602c0.94141 0.92969 1.5391 2.2188 1.5391 3.6484 0 0.17188-0.03125 0.35156-0.050781 0.51953l6.1719 6.1602c0.67969 0.69141 1.0508 1.5898 1.0508 2.5391 0 0.94922-0.37109 1.8711-1.0508 2.5391z"></path>   <path d="m46.262 88.93c-10.18-1.6016-18.238-9.6719-19.852-19.84h-3.3711c-0.17969 0-0.35156-0.019532-0.5-0.050782 1.6406 12.34 11.441 22.141 23.781 23.781-0.03125-0.17187-0.050781-0.32031-0.050781-0.5v-3.3789z"></path>   <path d="m21.34 65.34c0 0.94922 0.76172 1.6992 1.6992 1.6992h3.6289c0.92969 0 1.6914-0.73828 1.6914-1.6719 0-0.92969-0.75-1.7109-1.6914-1.7109h-3.6289c-0.92969 0-1.6992 0.75-1.6992 1.6914z"></path>   <path d="m26.41 61.621c1.6094-10.18 9.6719-18.25 19.852-19.852v-3.3789c0-0.17188 0.019531-0.32812 0.050781-0.5-12.34 1.6484-22.141 11.441-23.781 23.789 0.16016-0.03125 0.32031-0.050782 0.5-0.050782h3.3711z"></path>   <path d="m50.012 87c-0.94922 0-1.6992 0.75-1.6992 1.6914v3.6289c0 0.92969 0.73828 1.6914 1.6719 1.6914 0.92969 0 1.6992-0.75 1.6992-1.6914v-3.6289c0-0.92969-0.73828-1.6914-1.6719-1.6914z"></path>   <path d="m19.301 19.301c1.1211 0 2.0391-0.92188 2.0391-2.0508v-9.2109c0-1.1211-0.92188-2.0391-2.0391-2.0391-1.1211 0-2.0508 0.92188-2.0508 2.0391v9.2109c0 1.1289 0.92188 2.0508 2.0508 2.0508z"></path>   <path d="m54.352 68.031c-0.55078 0.89062-1.3594 1.6094-2.3281 2.0312l5.6016 5.6016c0.60156 0.60938 1.5781 0.60938 2.1914 0 0.28125-0.28906 0.44922-0.67187 0.44922-1.0898 0-0.42188-0.17188-0.80859-0.44922-1.0898l-5.4492-5.4492z"></path>   <path d="m53.078 65.352c0-1.7109-1.3789-3.0898-3.0781-3.0898s-3.0781 1.3789-3.0781 3.0898c0 1.7109 1.3789 3.0781 3.0781 3.0781s3.0781-1.3789 3.0781-3.0781z"></path>   <path d="m39.762 19.301c1.1289 0 2.0508-0.92188 2.0508-2.0508l-0.003906-9.2109c0-1.1211-0.92188-2.0391-2.0508-2.0391-1.1289 0-2.0391 0.92188-2.0391 2.0391v9.2109c0 1.1289 0.92188 2.0508 2.0391 2.0508z"></path>  </g> </svg>
                    <span>Future Appointments</span><span className='tooltip'>Future Appts</span><i>{this.state.futureappts.length}</i></li>

                    {/* <li onClick={() => this.handleClick('RaiseDisputelist')} className={activetab === 'RaiseDisputelist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                    Raise Dispute<i>{this.state.RaiseDisputelist.length}</i></li> */}

                     <li onClick={() => this.handleClick('medical_list')} className={activetab === 'medical_list' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="77.38 31.95 345.25 436.1"><path clipRule="evenodd" d="M113.718,31.949c-20.079,0-36.343,16.264-36.343,36.34v363.421  c0,20.078,16.264,36.34,36.343,36.34h272.566c20.079,0,36.34-16.262,36.34-36.34V158.417c0-12.173-4.81-22.982-12.536-30.796  l-82.497-82.319c-8.173-8.265-19.628-13.352-32.164-13.352H113.718z M240.914,95.548c0-9.996,8.177-18.173,18.172-18.173  c9.991,0,18.172,8.177,18.172,18.173v68.14c0,7.542,6.087,13.629,13.626,13.629h68.143c9.99,0,18.172,8.175,18.172,18.17  c0,9.996-8.182,18.171-18.172,18.171h-81.769c-20.079,0-36.344-16.264-36.344-36.341V95.548z" fill="#000000" fillRule="evenodd"></path></svg>
                   <span>Medical Histories</span> <span className='tooltip'>Medical Histories </span><i>{this.state.medicalHistorylist.length}</i> </li>  

                    <li onClick={() => this.handleClick('medical_condition')} className={activetab === 'medical_condition' ? 'active cursor-pointer' : ' cursor-pointer'}>
                      <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" x="0px" y="0px" viewBox="192.36 71.25 816.28 1057.75"><g data-name="Group"><path data-name="Compound Path" d="M756.82,184.16a51.33,51.33,0,0,0-51.41-51.4H661.23a60.73,60.73,0,1,0-121.45,0h-44.2a51.33,51.33,0,0,0-51.4,51.4v75H756.82ZM600.49,157.37a24.61,24.61,0,1,1,24.61-24.61A24.62,24.62,0,0,1,600.49,157.37Z"></path><path data-name="Compound Path" d="M966.27,196H782.8v89.17H418.2V196H234.73a42.37,42.37,0,0,0-42.37,42.37V1086.6A42.37,42.37,0,0,0,234.73,1129H966.27a42.37,42.37,0,0,0,42.37-42.37V238.34A42.37,42.37,0,0,0,966.27,196ZM459.66,890.46l-83.81,75.35a16.28,16.28,0,0,1-22.53-.7l-40-40.81a16.31,16.31,0,1,1,23.29-22.85l29.11,29.68,72.19-64.92a16.31,16.31,0,0,1,21.82,24.25Zm0-181-83.81,75.35a16.28,16.28,0,0,1-22.53-.7l-40-40.81a16.31,16.31,0,1,1,23.29-22.85l29.11,29.68,72.19-64.92a16.31,16.31,0,0,1,21.82,24.25ZM500,388.78c68.66-34.13,100.49,42,100.49,42S632,355.3,701,388.78c69.18,33.59,23.19,165.36-100.49,215.7C476.82,554.14,433.68,421.75,500,388.78ZM884.49,938.45H504.65c-6.14,0-11.13-7.31-11.13-16.31s5-16.31,11.13-16.31H884.49c6.14,0,11.13,7.29,11.13,16.31S890.63,938.45,884.49,938.45Zm0-181H504.65c-6.14,0-11.13-7.31-11.13-16.31s5-16.31,11.13-16.31H884.49c6.14,0,11.13,7.29,11.13,16.31S890.63,757.45,884.49,757.45Z"></path></g></svg>
                    <span>Medical Conditions</span> <span className='tooltip'> Medical Conditions </span> <i>{this.state.medicalCondition.length}</i> </li> 
                
                </ul>
                <div className="vertical-menu-content">

                      <div className={activetab === 'userdetail' ?"content-div userdetail active":"content-div userdetail"} id="userdetail">
                      <div className="title text-start">
                      <h3>User Demographics</h3>
                      </div>
                      <div className="form-row">
                        <div className="details_left">
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Username<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.username}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Firstname<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.firstname}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Lastname<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{lastname}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Email<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.email}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Mobile number<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{mobileno}</p>
                              </div>
                              
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>User Type<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{ this.state.userlistview.user_type && `${this.Capitalize(this.state.userlistview.user_type)}`}</p>
                              </div>
                            </div>

                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Location<span>:</span></p>
                              </div>
                            <div className="view-details-two">
                                  <p>{ this.state.userlistview.location}</p>
                              </div>
                            </div>

                            {((this.state.userlistview.membership_name!='')&&(this.state.userlistview.membership_name!=null))&&<div className="view-details">
                              <div className="view-details-one">
                                  <p>Subscribed Plan<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{subscribed_plan_name}</p>
                              </div>
                              
                            </div>}

                            {/* <div className="view-details">
                              <div className="view-details-one">
                                  <p>Paid Plan amount<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{plan_paid_amount}</p>
                              </div>
                            </div> */}

                             {/*  <div className="view-details">
                              <div className="view-details-one">
                                  <p>Transaction ID<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{transactionId}</p>
                              </div>
                              </div> */}
                              {(this.state.userlistview.admin_type!== null && this.state.userlistview.adminname!== undefined) && <div className="view-details">
                              <div className="view-details-one">
                                  <p>Status Changed by<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.adminname+' ('+this.state.userlistview.admin_type+')'}</p>
                              </div>
                              </div>}


                        </div>
                      </div>
                      </div>
                      <div className={activetab === 'familylist' ?"content-div familylist active":"content-div familylist"} id="familylist">
                      <div className="title text-start">
                        <h3>{this.state.ShowFamilyDocuments==false?'Pets':'Medical Documents'}</h3>
                      </div>
                      {this.state.ShowFamilyDocuments==false?
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Pet Name</th>
                                <th>Type</th>
                                <th>Color</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Weight</th>
                                <th>Allergies</th>
                                <th>Vaccination</th>
                                <th>Surgery</th>                                
                                {/* <th>Document</th> */}
                              </tr>
                            </thead>
                            <tbody>{this.familylist()}
                            </tbody>
                          </Table>
                        </div>:
                           <>{this.state.FamilyDocuments.map(
                              (file, Index) => {                                
                                return (
                                  <div className="form-row EHR-view">
                                  <div className="details_left">                               
                                        <div className="view-details-two m-0">
                                            <p onClick={() => this.downloadImage(mediaUrl+"familymedical/"+file.image,file.image)} >   
                                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="10.79 5 78.42 90"><g data-name="pdf"><path d="M87,25.34,70.92,7.75A8.46,8.46,0,0,0,64.69,5H19.23a8.45,8.45,0,0,0-8.44,8.44V86.56A8.45,8.45,0,0,0,19.23,95H80.77a8.45,8.45,0,0,0,8.44-8.44V31A8.4,8.4,0,0,0,87,25.34Zm-5.33,2.51H71.31A2.82,2.82,0,0,1,68.5,25V13.44Zm-.9,61.53H19.23a2.82,2.82,0,0,1-2.82-2.82V13.44a2.82,2.82,0,0,1,2.82-2.82H62.87V25a8.45,8.45,0,0,0,8.44,8.44H83.59V86.56A2.82,2.82,0,0,1,80.77,89.38Z"/><path d="M67.22,28.89,66.5,9H14.67V91.33H85.5V29.12ZM40.4,53.48a6.21,6.21,0,0,1-1.79,2.22A7.6,7.6,0,0,1,36,57a11.54,11.54,0,0,1-3.16.42H31.17a1,1,0,0,0-.94.94v5.24a.94.94,0,0,1-.94.94H26.44a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h6.27a14.69,14.69,0,0,1,3.26.34A7.33,7.33,0,0,1,38.61,45a5.54,5.54,0,0,1,1.79,2.09,7.06,7.06,0,0,1,.66,3.21A7.24,7.24,0,0,1,40.4,53.48Zm18.73,5.15A8.69,8.69,0,0,1,57,61.93a8.58,8.58,0,0,1-3.24,2,12.9,12.9,0,0,1-4.2.65H44.35a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h5a14.65,14.65,0,0,1,4.35.61A8.78,8.78,0,0,1,57,46a8.28,8.28,0,0,1,2.12,3.24,13.07,13.07,0,0,1,.75,4.67A13.36,13.36,0,0,1,59.13,58.63ZM75.82,46.58a.94.94,0,0,1-.94.94H68.26a.94.94,0,0,0-.94.94v3a.94.94,0,0,0,.94.94h5.4a.94.94,0,0,1,.94.94v2.12a.94.94,0,0,1-.94.94h-5.4a.94.94,0,0,0-.94.94v6.27a.94.94,0,0,1-.94.94H63.52a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94H74.88a.94.94,0,0,1,.94.94Z"/><path d="M53.37,48.76a4.33,4.33,0,0,0-1.87-1.08,8.5,8.5,0,0,0-2.45-.32h-.9V60.69h.9a7.84,7.84,0,0,0,2.45-.35,4.65,4.65,0,0,0,1.87-1.14,5.6,5.6,0,0,0,1.21-2.08A10.08,10.08,0,0,0,55,53.93a9.8,9.8,0,0,0-.43-3.14A5.23,5.23,0,0,0,53.37,48.76Z"/><path d="M35.39,48a5.42,5.42,0,0,0-3-.68H31.17a1,1,0,0,0-.94.94V52.7a1,1,0,0,0,.94.94h1.38q3.87,0,3.87-3.35A2.55,2.55,0,0,0,35.39,48Z"/></g></svg> 
                                             {file.image} </p> 
                                        </div>
                                  </div>  
                                  {/* <div className='frame open'>
                                  <iframe  class="responsive-iframe"  src={mediaUrl+"familymedical/"+file.image}>       
                                  </iframe>
                                  </div> */}

                                  </div>
                                );
                              }
                            )}                          
                         </>
                         }
                        
                      </div>
                      <div className={activetab === 'pastappointment' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                       
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Past Appointment Lists</h3>} 

                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Pet Parent</th>
                                <th>Pet </th>
                                <th>Reason</th>
                                <th>Schedule On</th>
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.pastappointment()}<br/>
                            
                            </tbody>}
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className={activetab === 'ongoingappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Ongoing Appointments</h3>}
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:<tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Pet Parent</th>
                                <th>Pet </th>
                                <th>Reason</th>
                                <th>Schedule On</th>
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.ongoingappts()}<br/>
                            </tbody>}
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>


                      <div className={activetab === 'futureappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                     <h3>Future Appointments</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Pet Parent</th>
                                <th>Pet </th>
                                <th>Reason</th>
                                <th>Schedule On</th>
                               
                               
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                {/* <th>Action</th> */}
                              </tr>
                            </thead>                           
                            <tbody> {this.futureappts()}<br/>
                            </tbody>
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className={activetab === 'RaiseDisputelist' ?"content-div RaiseDisputelist active":"content-div RaiseDisputelist"} id="RaiseDisputelist">
                      <div className="title text-start">
                        <h3>Raised Disputes </h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Dispute</th>
                                <th>Appt ID</th>
                                <th>Provider</th>
                                <th>Comment</th>
                                <th>Status</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.RaiseDisputelist()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      <div className={activetab === 'medical_list' ?"content-div medical_list active":"content-div medical_list"} id="medical_list">
                      <div className="title text-start">
                        <h3>Medical Histories</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>File</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalHistory()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      <div className={activetab === 'medical_condition' ?"content-div medical_condition active":"content-div medical_condition"} id="medical_condition">
                      <div className="title text-start">
                        <h3>Medical Conditions</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Medical Condition</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalCondition()}<br/>                            
                            </tbody>
                          </Table>                         
                        </div>
                      </div>
                   
                </div>
              </div>
             
                  
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    userlistview: state.userlistview
    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getViewUserList: (userid) =>{
       dispatch({ type: GET_VIEWUSERLIST,userid });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(ViewEHR));